<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update_local(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <div class="w-100 table-responsive table-fix-head overflow-y--1" v-if="array_options.room_type_id.length" style="margin-top:20px;">
                    <table class="table">
                        <thead style="background-color: #f1f1f1;">
                            <tr>
                                <th class="header-item-manual" v-for="(item, i) in room_type_table_headers" :key="i" scope="col" v-html="item.name"/>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in room_types" :key="i">
                                <td>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="`checkedUpdate${i}`" type="checkbox" class="custom-control-input" v-model="item.checked"/>
                                        <label :for="`checkedUpdate${i}`" class="custom-control-label ml-2"/>
                                    </span>
                                </td>
                                <td v-html="item.name"/>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'rest_api',
        'notyf',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format:    FormResources.form_format,
            room_type_table_headers: Resources.room_type_table_headers,
        }
    },

    watch: {
        "single_object"(val)
        {
           if (val) {
                this.room_types.forEach(value => value.checked = false)
                val.room_type_id.forEach(item => {
                    this.room_types.forEach(value => {
                        if(value.id == item) {
                            value.checked = true
                        }
                    })
                })
           }
        }
    },
    
    methods: {
        form_submit_update_local(id, index) {
            const room_types = this.room_types.filter( item => item.checked).map(item => item.id)
            if (room_types.length) {
                this.single_object.room_type_id = room_types
                this.form_submit_update(id,index);
                return true;
            }
            this.notyf.error('Room Type is required')
            return false;
        }
    },

    mounted(){

    },

    computed: {
        room_types() {
            return [... this.array_options.room_type_id]
        }
    },
    
}
</script>